import { createSelector } from 'reselect';
import filter from 'lodash/filter';

const getCategories = state => state.categories.list;
const getSearchText = state => state.categories.filter;

/**
  @name getFilteredCategories
  Selector to obtain the searched categories from the list
*/
const getFilteredCategories = createSelector(getCategories, getSearchText, (categories, text) => {
  if (text) {
    const list = filter(categories, category => category.name.toLowerCase().includes(text.toLowerCase()))
    return list;
  }
  return categories;
});

export default getFilteredCategories;



// WEBPACK FOOTER //
// ./src/utils/selectors/getFilteredCategories.js